import './App.css';
import { LiveProvider, LivePreview } from 'code-live-sandbox';
import React from 'react';
import * as ReactAll from 'react';
import {useState, useEffect} from 'react';

function App() {
  const [code, setCode] = useState('() => <p>Loading...</p>');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codeURL = params.get('code');
    if (codeURL) {
      fetch(codeURL)
        .then(response => response.text())
        .then(text => setCode(text))
        .catch(error => console.error('Error fetching code:', error));
    }
  }, []);

  useEffect(() => {
    console.log(code);
  }, [code]);

  return (
    <div className="App" style={{width: "100%", height: "100%", display: "flex", overflow: "scroll"}}>
      <LiveProvider
        code={code}
        scope={{
            import: {
                react: { ...ReactAll, default: React }
            }
        }}
        style={{width: "100%", height: "100%", overflow: "scroll"}}
        >
        <LivePreview />
      </LiveProvider>
    </div>
  );
}

export default App;
